import React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { MdOutlineLocationOn } from "react-icons/md";
import ExpandableDescription from "../../../atoms/ExpandableDescription";
import { isHtmlEmpty } from "../../dashboard/todos/todoColumns";

interface BookingTypeImageProps {
  src?: string | null;
  alt: string;
  className?: string;
}

export const BookingTypeImage: React.FC<BookingTypeImageProps> = ({
  src,
  alt,
  className,
}) =>
  src ? (
    <img
      src={src}
      alt={alt}
      className={twMerge(
        "aspect-video w-full rounded-lg border border-gray-200 object-cover",
        className
      )}
    />
  ) : null;

export const BookingTypeDescription: React.FC<{ html?: string | null }> = ({
  html,
}) => {
  const { t } = useTranslation("clientView");
  if (!html || isHtmlEmpty(html)) return null;
  return (
    <ExpandableDescription
      content={html}
      maxLength={300}
      maxLines={5}
      expandText={t("key97") as string}
      collapseText={t("key107") as string}
      textClassName="text-sm text-gray-700 leading-relaxed"
      buttonClassName="mt-2 inline-flex items-center text-xs font-medium text-blue-600 transition-colors hover:text-blue-800"
    />
  );
};

export const BookingTypeLocation: React.FC<{ location?: string | null }> = ({
  location,
}) =>
  location?.trim() ? (
    <p className="flex items-start gap-2 text-sm text-gray-700">
      <MdOutlineLocationOn
        size={18}
        aria-hidden="true"
        className="mt-0.5 shrink-0 text-gray-500"
      />
      <span className="min-w-0 flex-1 whitespace-pre-line break-words">
        {location.trim()}
      </span>
    </p>
  ) : null;
